// extracted by mini-css-extract-plugin
module.exports = {"item":"P_dh","item__image":"P_dj"};